import { Injectable } from '@angular/core'
import { ParseService } from '../../parse.service'

declare global {
    interface Window {
        lintrk?: {
            (eventName: 'track', eventValue: { conversion_id: number }): void
        }
    }
}

@Injectable({
    providedIn: 'root',
})
export class LinkedInPixelService {
    constructor(private parseService: ParseService) {}

    private track(conversion_id: number) {
        if (document.location.host !== 'app.wisepelican.com') {
            return
        }

        if (!window.lintrk) {
            return
        }

        window.lintrk('track', { conversion_id })
    }

    trackAddToCart() {
        try {
            this.track(14853730)
        } catch (err) {
            this.parseService.reportUIError(err, 'LinkedInPixelService.trackAddToCart', '')
        }
    }

    trackSignUp() {
        try {
            this.track(1207068)
        } catch (err) {
            this.parseService.reportUIError(err, 'LinkedInPixelService.trackSignUp', '')
        }
    }

    trackPurchase() {
        try {
            this.track(14853722)
        } catch (err) {
            this.parseService.reportUIError(err, 'LinkedInPixelService.trackPurchase', '')
        }
    }
}
